/**
 * Damage per second is counted in tenths (ADR 0015): the smallest pieces give
 * a fifth of a weapon, and whole numbers would round them to nothing at the
 * first levels. Every sum and every upgrade goes back through `roundDps`, so
 * floating point never shows up as 14.200000000000001.
 */
export function roundDps(value) {
    return Math.round(value * 10) / 10;
}
//# sourceMappingURL=dps.js.map